import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:4001/api';
const API = axios.create({ baseURL: BASE, timeout: 30000 });

API.interceptors.request.use(config => {
  const token = localStorage.getItem('tikoo_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const eventsAPI = {
  list: () => API.get('/tikoo/events'),
  get: (id) => API.get(`/tikoo/events/${id}`),
  create: (data) => API.post('/tikoo/events', data),
  update: (id, data) => API.put(`/tikoo/events/${id}`, data),
  myEvents: () => API.get('/tikoo/events/organizer/my'),
};

export const purchaseAPI = {
  create: (data) => API.post('/tikoo/purchase', data),
  get: (id) => API.get(`/tikoo/purchase/${id}`),
  byEmail: (email) => API.get(`/tikoo/purchase/email/${email}`),
  verify: (code) => API.get(`/tikoo/purchase/verify/${code}`),
};

export const authAPI = {
  register: (data) => API.post('/tikoo/auth/register', data),
  login: (data) => API.post('/tikoo/auth/login', data),
  me: () => API.get('/tikoo/auth/me'),
};

export const payoutsAPI = {
  summary: () => API.get('/tikoo/payouts/summary'),
  my: () => API.get('/tikoo/payouts/my'),
  request: (data) => API.post('/tikoo/payouts/request', data),
};

export const superAPI = {
  stats: () => API.get('/tikoo/super/stats'),
  settings: () => API.get('/tikoo/super/settings'),
  updateSettings: (data) => API.put('/tikoo/super/settings', data),
  organizers: () => API.get('/tikoo/super/organizers'),
  updateOrganizer: (id, data) => API.put(`/tikoo/super/organizers/${id}`, data),
  events: () => API.get('/tikoo/super/events'),
  payouts: () => API.get('/tikoo/super/payouts'),
  updatePayout: (id, data) => API.put(`/tikoo/super/payouts/${id}`, data),
};

export default API;
